<div *ngIf="!isSnow" class="green-banner d-flex flex-column justify-content-center align-items-center text-center mb-6">
  <h1 class="display-3 text-white m-0 p-0" i18n="@@amadeus-direct.avc-credit-line.title">Value Hotels Credit Line</h1>
</div>

<div *ngIf="viewAvcCreditLine; else noPermissions">
  <div *ngIf="!errorMessage; else errors">
    <div
      *ngIf="!(creditLineStatusLoading$ | async); else loadingContainer"
      class="dashboard-avc container px-lg-10 px-md-10"
    >
      <h1 i18n="@@amadeus-direct.avc-credit-line.header">Your credit line</h1>
      <span
        *ngIf="loggedInUserIsCreditLineOwner() || loggedInUserIsAdministrativeHead()"
        class="font-total-granted-label"
        >{{ totalGrantedAllOffices }} {{ getTotalGrantedForAllOffices() | number: '1.2-2' }}
        {{ this.creditLineStatus.body.agencyData.salesCurrency }}</span
        >
      <form *ngIf="loggedInUserIsAdministrativeHead()">
        <div class="mb-6 mt-6 dropdown-width">
          <label
            for="creditLineOwnerSelect"
            class="form-label"
            i18n="@@amadeus-direct.avc-credit-line.credit-line-owner"
            >Credit line owner</label
          >
          <ng-select
            labelForId="creditLineOwnerSelect"
            [selectOnTab]="true"
            name="creditLineOwnerSelect"
            [items]="creditLineOwnersList"
            [(ngModel)]="selectedCreditLineOwner"
            [searchable]="true"
            [clearable]="false"
            [markFirst]="true"
            (change)="onCreditLineOwnerChange($event)"
          ></ng-select>
        </div>
      </form>
      <form>
        <div class="mb-6 mt-6 dropdown-width">
          <label for="agencySelect" class="form-label" i18n="@@amadeus-direct.avc-credit-line.office">Office</label>
          <ng-select
            labelForId="agencySelect"
            [selectOnTab]="true"
            name="agencySelect"
            [items]="agenciesList"
            [(ngModel)]="selectedAgency"
            [searchable]="true"
            [clearable]="false"
            [markFirst]="true"
            (change)="onAgencyChange($event)"
          ></ng-select>
        </div>
      </form>
      <div
        *ngIf="
          (loggedInUserIsCreditLineOwner() || isNoNetworkAgency() || loggedInUserIsAdministrativeHead()) &&
          !errorMessageChild
        "
      >
        <div class="d-flex margin-top">
          <div class="column-width">
            <div i18n="@@amadeus-direct.avc-credit-line.granted">Granted</div>
            <div class="font-amounts">
              {{ getSelectedAgency().initialAmount | number: '1.2-2' }}
              {{ getSelectedAgency().salesCurrency }}
            </div>
          </div>
          <div class="column-width">
            <div i18n="@@amadeus-direct.avc-credit-line.available">Available</div>
            <div class="font-amounts">
              {{ getSelectedAgency().openAmount | number: '1.2-2' }}
              {{ getSelectedAgency().salesCurrency }}
            </div>
          </div>
          <div class="column-width">
            <div i18n="@@amadeus-direct.avc-credit-line.spent">Spent</div>
            <div class="font-amounts">
              {{ getSelectedAgency().usedAmount | number: '1.2-2' }}
              {{ getSelectedAgency().salesCurrency }}
            </div>
          </div>
          <div class="column-width">
            <div i18n="@@amadeus-direct.avc-credit-line.percentage-spent">Percentage spent</div>
            <div class="font-amounts">{{ getSelectedAgency().percentageUsed }}%</div>
          </div>
        </div>
        <div *ngIf="inlineErrorMessageChild" class="d-flex error-message">
          <figure class="figure error-message-figure" data-test="kaliuk">
            <svg class="kaliuk kaliuk-big">
              <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
            </svg>
            <figcaption class="figure-caption">
              <h4>
                {{ inlineErrorMessageChild }}
              </h4>
            </figcaption>
          </figure>
        </div>
        <app-avc-credit-line-chart *ngIf="showChart()" [data]="creditLineChartInput"></app-avc-credit-line-chart>
        <div *ngIf="inlineErrorMessage" class="d-flex error-message">
          <figure class="figure" data-test="kaliuk">
            <svg class="kaliuk kaliuk-big">
              <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
            </svg>
            <figcaption class="figure-caption">
              <h4>
                {{ inlineErrorMessage }}
              </h4>
            </figcaption>
          </figure>
        </div>
      </div>
      <div
        *ngIf="(loggedInUserIsCreditLineOwner() || loggedInUserIsAdministrativeHead()) && errorMessageChild"
        class="d-flex error-message"
      >
        <figure class="figure error-message-figure" data-test="kaliuk">
          <svg class="kaliuk kaliuk-big">
            <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
          </svg>
          <figcaption class="figure-caption">
            <h4>
              {{ errorMessageChild }}
            </h4>
          </figcaption>
        </figure>
      </div>
      <div *ngIf="isChildAgency()">
        <div class="card-body">
          <div class="card-title" i18n="@@amadeus-direct.avc-credit-line.available">Available</div>
          <div class="font-amounts">
            {{ getSelectedAgency().openAmount | number: '1.2-2' }}
            {{ getSelectedAgency().salesCurrency }}
          </div>
        </div>
      </div>

      <p class="fst-italic mt-5" *ngIf="!errorMessageChild">
        <span i18n="@@amadeus-direct.avc-credit-line.legal-disclaimer.updates">Data update can take up to 3 hours.</span>
        <br />
        <span i18n="@@amadeus-direct.avc-credit-line.legal-disclaimer.conversion">
          For currencies other than EUR, changes in exchange rates may affect the amounts displayed.
        </span>
      </p>
    </div>
  </div>
</div>

<ng-template #loadingContainer>
  <div class="d-block py-2 mt-4 loading-container text-center" data-test="loading-indicator">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
</ng-template>

<ng-template #noPermissions>
  <div class="d-flex justify-content-center">
    <figure class="figure" data-test="kaliuk">
      <svg class="kaliuk kaliuk-big">
        <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
      </svg>
      <figcaption class="figure-caption">
        <h4 i18n="@@amadeus-direct.avc-credit-line.no-permissions">
          You don't have permission to view this data.
        </h4>
      </figcaption>
    </figure>
  </div>
</ng-template>

<ng-template #errors>
  <div class="d-flex justify-content-center">
    <figure class="figure" data-test="kaliuk">
      <svg class="kaliuk kaliuk-big">
        <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
      </svg>
      <figcaption class="figure-caption">
        <h4>
          {{ errorMessage }}
        </h4>
      </figcaption>
    </figure>
  </div>
</ng-template>
